import { HYDRATE } from 'next-redux-wrapper';

import { CLOSE_CHAT,
    LOADED_CHAT,
    OPEN_CHAT } from '../actionTypes/chat';

const initialState = {
    isOpen: false,
    isLoaded: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.chat };
        case OPEN_CHAT: {
            return {
                ...state,
                isOpen: true,
            };
        }
        case CLOSE_CHAT: {
            return {
                ...state,
                isOpen: false,
            };
        }
        case LOADED_CHAT: {
            return {
                ...state,
                isLoaded: action.payload,
            };
        }
        default: {
            return state;
        }
    }
};
